var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 16",
  preserveAspectRatio: "xMidYMid",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Input/Elements/Icon-Container/Auto-Approve",
  transform: "translate(-3.000000, -1.000000)",
  fill: "#41505F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6316488,7.39797869 L9.98338791,7.39797869 C9.6620385,7.39797869 9.4005483,7.13648849 9.4005483,6.81513908 L9.4005483,1.58218453 C9.4005483,1.01509734 8.67593689,0.785111978 8.34513603,1.2450827 L3.10903099,9.67892938 C2.83493885,10.0632885 3.10903099,10.5988708 3.58160365,10.5988708 L7.22041311,10.5988708 C7.54176251,10.5988708 7.80325272,10.860361 7.80325272,11.1817104 L7.80325272,16.4178155 C7.80325272,16.9849027 8.52786413,17.214888 8.85866499,16.7549173 L14.107372,8.31792013 C14.3783136,7.93356104 14.1042215,7.39797869 13.6316488,7.39797869 Z",
  id: "Auto-Approve"
})))));
export { SvgBolt as ReactComponent };
export default __webpack_public_path__ + "static/media/bolt.d629a6bf.svg";